import { connect } from 'react-redux'
import { compose } from 'redux'
import LivePlayer from './LivePlayer'
import PlayerApi from '../../utils/playerApi'
import withDialogs from '../../hocs/withDialogs'
import withLiveEvents from './withLiveEvents'
import {
  PLAYER_ERROR_CODES_MAP,
  UNKNOWN_ERROR,
} from '../../constants'

const playerApi = PlayerApi()

const mapStateToProps = ({ playerApiCache, user }, { channel, groupToken }) => {
  const { results, reason: error } = playerApiCache[`/streams/${channel}`]
  const { currentlySubscribed, isLoggedIn, loginChecked } = user

  return {
    groupToken,
    contentType: 'live',
    currentlySubscribed,
    isLoggedIn,
    loginChecked,
    ...(results && {
      channel: results.channel,
      endTime: results.now?.endTime,
      guid: results.guid,
      poster: encodeURIComponent(results?.images?.[0]?._filepath),
      programmeGuid: results.now?.programme?.guid,
      programmeName: results.now?.programme?.name,
      matId: results.now?.matId,
      region: results.region,
      restartEnabled: Boolean(results.now?.restartEnabled && results.restartUrl),
      restartUrl: results.now?.restartEnabled && results.restartUrl && results.now?.isRestartScrubbable && results.restartScrubbableUrl && results.restartScrubbableUrl !== 'null' ? encodeURIComponent(`${results.restartScrubbableUrl}`) : encodeURIComponent(`${results.restartUrl}`),
      scrubEnabled: Boolean(results.now?.restartEnabled && results.now?.isRestartScrubbable),
      startTime: results.now?.startTime,
      stream: results.stream,
      streamUrl: encodeURIComponent(results.streamUrl),
      title: results.now?.title,
      videoId: results.videoId,
    }),
    ...(error && {
      error: PLAYER_ERROR_CODES_MAP[error.code] || UNKNOWN_ERROR,
    }),
  }
}

const mapDispatchToProps = (dispatch, { channel }) => ({
  dispatch,
  onPostcodeSubmit: async (postcode) => {
    const {
      results: { grouptoken },
    } = await playerApi({
      dispatch,
      path: '/grouptoken',
      query: {
        postcode,
        device: 'desktop',
      },
    })
    // player-api takes a groupToken param but returns a grouptoken response
    playerApi({
      dispatch,
      path: `/streams/${channel}`,
      query: { groupToken: grouptoken },
    })
    playerApi({
      dispatch,
      path: '/streams',
      query: { groupToken: grouptoken },
    })
  },
})

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLiveEvents,
  withDialogs,
)

export default enhance(LivePlayer)
